import { Link } from "react-router-dom";
import { Logo, Monogram } from "@/components/Logo";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-charcoal border-t border-cream/10 py-14 overflow-hidden">
      <Monogram stroke="#f4e7d7" className="pointer-events-none absolute -bottom-20 right-8 w-[300px] opacity-[0.05]" />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-8 relative z-10">
        <Logo color="#f4e7d7" sub="#a4946c" />
        <p className="font-sans text-cream/40 text-xs uppercase tracking-[0.2em] max-w-xs">
          SW Washington & Oregon · Custom cabinetry & millwork
        </p>
        <div className="flex items-center gap-6">
          <p className="font-sans text-cream/40 text-xs">© {new Date().getFullYear()} Ashmark</p>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="font-sans text-cream/40 text-xs uppercase tracking-[0.2em] hover:text-terracotta transition-colors"
          >
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
